import * as type from './constant';

export const getDayOff = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getDayOffSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getDayOffError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addDayOff = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addDayOffSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateDayOff = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateDayOffSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteDayOff = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteDayOffSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationDayOffError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
